import { render, staticRenderFns } from "./AccotationWithoutDoughnut.vue?vue&type=template&id=424f8cf6"
import script from "./AccotationWithoutDoughnut.vue?vue&type=script&lang=js"
export * from "./AccotationWithoutDoughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports